import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Llegaba cansada y siempre pedía delivery. Ahora tengo todo listo y ahorro un montón.',
  name: 'Marina G.',
  location: 'Buenos Aires'
}, {
  quote: 'Lo mejor es la tranquilidad. Abro el freezer y ya está todo resuelto.',
  name: 'Lucía R.',
  location: 'Córdoba'
}, {
  quote: 'Pensé que me iba a aburrir, pero la variedad es enorme.',
  name: 'Sofía M.',
  location: 'Rosario'
}, {
  quote: 'Siempre pensé que congelar arruinaba la comida. Probé medio desconfiado y la verdad es que queda igual de bien. Me sorprendió.',
  name: 'Javier M.',
  location: 'Buenos Aires'
}, {
  quote: 'No me gusta cocinar y soy bastante desordenado. Con el paso a paso pude hacerlo sin volver un caos la cocina. Es mucho más simple de lo que parece.',
  name: 'Matías R.',
  location: 'Rosario'
}];
export function TestimonialsSection() {
  return <section className="py-5 md:py-7 px-4 bg-[#F7F5F0] text-text-primary" data-id="element-195">
      <div className="max-w-3xl mx-auto" data-id="element-196">
        <h2 className="text-xl md:text-3xl text-center mb-4 md:mb-5 font-bold tracking-tight" data-id="element-197">
          Lo que dicen quienes ya lo aplicaron
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2.5 md:gap-3" data-id="element-198">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-3 md:p-4 border border-black/5 rounded-2xl shadow-sm flex flex-col" data-id="element-199">
              <div className="flex text-accent mb-1.5" data-id="element-200">
                {[...Array(5)].map((_, j) => <Star key={j} size={12} fill="currentColor" data-id="element-201" />)}
              </div>
              <p className="text-[11px] md:text-xs text-text-secondary italic leading-relaxed mb-2 font-medium flex-1" data-id="element-202">
                "{t.quote}"
              </p>
              <p className="text-[9px] md:text-[10px] font-bold text-text-primary uppercase tracking-wider" data-id="element-203">
                {t.name} · {t.location}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}